var _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredHits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33336 6.66667L3.33336 33.3333L36.6667 33.3333L36.6667 11.6667L31.6667 6.66667L3.33336 6.66667ZM35 31.6667L35 12.5L30.8334 8.33333L5.00002 8.33333L5.00002 31.6667L35 31.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 11.6667L28.3334 11.6667L28.3334 15L31.6667 15L31.6667 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6667L21.6667 11.6667L21.6667 15L25 15L25 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667L18.3334 11.6667L18.3334 15L15 15L15 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 11.6667L8.33336 11.6667L8.33336 15L11.6667 15L11.6667 11.6667Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3333L8.33336 18.3333L8.33336 21.6667L11.6667 21.6667L11.6667 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3333L18.3334 18.3333L18.3334 21.6667L15 21.6667L15 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3333L21.6667 18.3333L21.6667 21.6667L25 21.6667L25 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 18.3333L31.6667 18.3333L31.6667 21.6667L28.3334 21.6667L28.3334 18.3333Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 25L31.6667 25L31.6667 28.3333L28.3334 28.3333L28.3334 25Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25L21.6667 25L21.6667 28.3333L25 28.3333L25 25Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 25L18.3334 28.3333L15 28.3333L15 25L18.3334 25Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 28.3333L11.6667 25L8.33336 25L8.33336 28.3333L11.6667 28.3333Z",
    fill: "#888888"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#FEFEFE",
    stroke: "#006AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.35L16.8981 6.21325L13.4473 7.92496L10.9271 4.63687L15 2.35ZM10.8136 4.87566L13.2787 8.09188L12.0829 12.0212L11.2014 6.6542L11.1887 6.57675L11.1271 6.52344L10.8206 6.25822L10.7601 5.00789L10.8136 4.87566ZM12.7562 13.8727L12.7726 13.8841L14.2798 9.78284L12.7562 13.8727ZM14.2826 9.77913L16.0302 8.76829L16.0376 8.7511L14.2826 9.77913ZM11.8678 12.1976L11.8237 12.2664L11.0835 11.6916L10.8361 6.5785L10.9629 6.68822L11.8678 12.1976ZM12.5536 13.731L12.5313 13.7155L12.2297 13.322L12.171 12.556L13.5126 8.14728L16.8004 6.51646L16.1874 8.39773L14.1523 9.58984L14.0806 9.63186L14.0528 9.70647L12.5536 13.731Z",
    fill: "#006AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2826 9.77916L16.0301 8.76832L16.0376 8.75113L14.2826 9.77916ZM12.5521 13.7349L12.5313 13.7155L12.2297 13.322L12.171 12.556L13.5126 8.14732L16.8004 6.51649L16.1874 8.39776L14.1523 9.58987L14.0806 9.6319L14.0528 9.70651L12.5521 13.7349Z",
    fill: "#0059CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.35L16.8981 6.21325L13.4473 7.92496L10.9271 4.63687L15 2.35Z",
    fill: "#559CFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14038 7.98081L6.44026 2.89276L9.38617 12.8912L9.27377 13.0409L7.70532 8.93694L5.14038 7.98081ZM12.0158 13.0534L10.5406 11.3543L9.5659 12.6519L6.66586 2.80917L10.9639 6.71055L12.0158 13.0534Z",
    fill: "#006AF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.08805L6.29988 3L9.0119 12.2046L9.13339 13.1481L7.56494 9.04418L5 8.08805Z",
    fill: "#0059CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4312 18.6583L16.8571 17.7105L18.1217 15.9007L14.1186 17.8946L13.4312 18.6583ZM14.4698 17.4647L17.8747 15.7687L15.7739 15.9164L14.7194 17.1448L14.4698 17.4647Z",
    fill: "#006AF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2832 17.8946L18.2863 15.9007L17.0217 17.7105L13.5958 18.6583L14.2832 17.8946Z",
    fill: "#0059CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99358 18.2793L3.4826 15.9972L7.74002 17.8333L8.00698 18.1567L8.3086 18.4378L8.88189 18.9721L4.99358 18.2793ZM5.87794 15.5827L7.40373 17.4259L7.42242 17.4486L3.61609 15.807L5.87794 15.5827Z",
    fill: "#006AF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99358 18.1556L3.4826 15.8735L7.74002 17.7097L8.00698 18.0331L8.3086 18.3142L8.88189 18.8484L4.99358 18.1556ZM7.1545 17.2094L7.40373 17.3023L7.42242 17.3249L7.1545 17.2094Z",
    fill: "#0059CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6031 7.25523L18.8226 12.1148L15.2904 12.5262L14.3111 9.78855L14.3211 9.76207L18.6031 7.25523ZM14.1807 10.135L15.0773 12.6417L12.6527 17.3625L12.9536 14.3901L12.7726 13.8841L12.7977 13.8083L14.1807 10.135ZM13.0999 19L12.471 19L12.579 18.0268L15.2876 12.7532L18.6253 12.3644L13.0999 19Z",
    fill: "#559CFB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1807 10.135L15.0773 12.6417L12.6527 17.3625L12.9536 14.3901L12.7726 13.8841L12.7974 13.8089L14.1807 10.135Z",
    fill: "#006AF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0999 19L12.471 19L12.5259 18.1302L15.2876 12.7532L18.6253 12.3643L13.0999 19Z",
    fill: "#0059CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42033 12.373L7.58719 9.35865L8.95158 12.9188L9.09281 13.322L8.54988 14.1652L9.09281 16.1891L9.90224 18.2844L6.42033 12.373ZM7.88357 17.731L9.0253 18.9733L10.0327 18.9733L6.2179 12.4967L3.13629 12.5655L4.033 13.5412L6.01624 15.402L7.88357 17.731ZM3 12.3436L6.20289 12.272L7.43463 9.09007L3.00001 7.44571L3 12.3436Z",
    fill: "#006AF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0253 18.5276L10.0327 18.5276L6.2179 12.0509L3.13629 12.1197L4.033 13.0955L6.01624 14.9563L7.88357 17.2853L9.0253 18.5276ZM3 11.8979L6.20289 11.8263L7.43463 8.64436L3.00001 7L3 11.8979Z",
    fill: "#559CFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0253 18.9733L10.0327 18.9733L6.2179 12.4966L3.13629 12.5654L4.03295 13.5411L6.01625 15.402L7.88364 17.7311L9.0253 18.9733Z",
    fill: "#0059CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3064 18.9606L12.7654 14.6616L10.9936 16.1672L11.3979 18.9646L12.3064 18.9606ZM11.1544 18.9645L10.7518 16.1791L8.87371 14.5707L10.2738 18.9605L11.1544 18.9645ZM10.8659 15.9714L8.7912 14.1947L10.5532 11.7315L12.7529 14.368L10.8659 15.9714Z",
    fill: "#006AF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1544 18.9645L10.7518 16.1791L8.87371 14.5707L10.2738 18.9605L11.1544 18.9645ZM10.8659 15.9714L8.7912 14.1947L10.5532 11.7315L12.7529 14.368L10.8659 15.9714Z",
    fill: "#559CFB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1544 18.9644L10.7518 16.1791L8.87372 14.5707L10.2738 18.9605L11.1544 18.9644Z",
    fill: "#0059CC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 40 3.8147e-06)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredHits);
export default __webpack_public_path__ + "static/media/expired-hits.394c1ecbfec337025e63b2de48c85dca.svg";
export { ForwardRef as ReactComponent };